import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mt-10px p-10px rounded-8px bg-[#f5f5f5]"
};
const _hoisted_2 = {
  class: "text-14px text-[#666] mb-8px flex items-center"
};
const _hoisted_3 = {
  class: "flex flex-wrap gap-8px"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "text-14px text-[#333] mb-4px"
};
const _hoisted_6 = {
  class: "text-12px text-[#999] ml-4px"
};
const _hoisted_7 = {
  class: "text-16px font-bold mb-12px"
};
const _hoisted_8 = {
  class: "max-h-[60vh] overflow-y-auto"
};
const _hoisted_9 = {
  class: "block mb-8px px-8px py-2px bg-[#f5f5f5] rounded-4px text-12px text-[#666] w-fit"
};
const _hoisted_10 = {
  class: "text-14px leading-[1.6] text-[#333] mt-[10px]"
};
import { computed, ref } from 'vue';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageKnowledge',
  props: {
    segments: {}
  },
  setup(__props) {
    const props = __props;
    const document = ref(null); // 知识库文档列表
    const dialogVisible = ref(false); // 知识引用详情弹窗
    const documentRef = ref(); // 知识引用详情弹窗 Ref
    /** 按照 document 聚合 segments */
    const documentList = computed(() => {
      if (!props.segments) return [];
      const docMap = new Map();
      props.segments.forEach(segment => {
        if (!docMap.has(segment.documentId)) {
          docMap.set(segment.documentId, {
            id: segment.documentId,
            title: segment.documentName,
            segments: []
          });
        }
        docMap.get(segment.documentId).segments.push({
          id: segment.id,
          content: segment.content
        });
      });
      return Array.from(docMap.values());
    });
    /** 点击 document 处理 */
    const handleClick = doc => {
      document.value = doc;
      dialogVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.segments && _ctx.segments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Icon, {
        icon: "ep:document",
        class: "mr-5px"
      }), _cache[1] || (_cache[1] = _createTextVNode(" 知识引用 "))]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentList.value, (doc, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "p-8px px-12px bg-white rounded-6px cursor-pointer transition-all hover:bg-[#e6f4ff]",
          onClick: $event => handleClick(doc)
        }, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(doc.title) + " ", 1), _createElementVNode("span", _hoisted_6, "（" + _toDisplayString(doc.segments.length) + " 条）", 1)])], 8, _hoisted_4);
      }), 128))])])) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
        visible: dialogVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        width: 600,
        trigger: "click",
        placement: "top-start",
        offset: 55,
        "popper-class": "knowledge-popover"
      }, {
        reference: _withCtx(() => [_createElementVNode("div", {
          ref_key: "documentRef",
          ref: documentRef
        }, null, 512)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(document.value?.title), 1), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.value?.segments, (segment, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-12px border-b-solid border-b-[#eee] last:border-b-0"
          }, [_createElementVNode("div", _hoisted_9, " 分段 " + _toDisplayString(segment.id), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(segment.content), 1)]);
        }), 128))])]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
});